import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { CommonStyles } from '../../styles';
import { widgetStyles } from '../../styles/theme';
import { pickImage } from '../../utils/image.utils';
import ExpenseFormItem from '../ExpenseWidget/ExpenseFormItem';

const UploadWidget = ({ state, onUpdate }) => {
  return (
    <View style={[widgetStyles.widget, CommonStyles.fullWidth]}>
      <TouchableOpacity
        onPress={() => pickImage((result) => onUpdate({ type: 'eventImage', value: result.uri }))}
      >
        <ExpenseFormItem
          label="Event Image"
          value={state.eventImage ? state.eventImage.substring(0, 20) : null}
          icon={!state.eventImage && 'image'}
          onClear={() => onUpdate({ type: 'eventImage', value: null })}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => pickImage((result) => onUpdate({ type: 'sponsorImage', value: result.uri }))}
      >
        <ExpenseFormItem
          label="Sponsor Image"
          value={state.sponsorImage ? state.sponsorImage.substring(0, 20) : null}
          icon={!state.sponsorImage && 'image'}
          style={widgetStyles.topBorder}
          onClear={() => onUpdate({ type: 'sponsorImage', value: null })}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => pickImage((result) => onUpdate({ type: 'venueImage', value: result.uri }))}
      >
        <ExpenseFormItem
          label="Venue Image"
          value={state.venueImage ? state.venueImage.substring(0, 20) : null}
          icon={!state.venueImage && 'image'}
          style={widgetStyles.topBorder}
          onClear={() => onUpdate({ type: 'venueImage', value: null })}
        />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({});

export default UploadWidget;
